<template>
  <div>
    <v-container fluid class="pa-8">
      <v-card class="px-5" outlined>
        <v-card-text>
          <div class="d-flex mb-4">
            <h2 class="custom-t">Compare Results&nbsp;&nbsp;</h2>
            <h3 class="ml-2 mt-2">({{ geneticId.length }} Animal)</h3>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              right
              height="40"
              width="116"
              color="primary"
              @click="$router.go(-1)"
              >BACK</v-btn
            >
          </div>
          <v-simple-table class="custom-table">
            <template v-slot:default>
              <thead style="background: #ffb443">
                <tr>
                  <th style="padding-left: 10px" class="text-left">
                    Animal Identification
                  </th>
                  <!-- <th class="text-left"></th>
                                <th class="text-left"></th>
                                <th class="text-left" style="min-width:70px">BW</th>
                                <th class="text-left" style="min-width:70px">WW</th>
                                <th class="text-left" style="min-width:70px">YW</th>
                                <th class="text-left" width="75px">REA</th>
                                <th class="text-left" width="75px">MARB</th>
                                <th class="text-left" width="75px">FAT</th>
                                <th class="text-center" width="75px">CW</th>
                                <th class="text-center" width="75px">YG</th>
                                <th class="text-center"> MILK </th>
                                <th class="text-center">TM</th>
                                <th class="text-center">CED </th>
                                <th class="text-center"> CEM</th>
                                <th class="text-center">STAY</th>
                                <th class="text-center">DOC</th> -->
                  <th
                    v-for="header in headers"
                    :key="header.value"
                    :style="{ 'min-width': header.width }"
                    class="text-left"
                  >
                    {{ header.text }}
                    <v-tooltip
                      top
                      color="black"
                      max-width="350"
                      v-if="
                        header.text != '' &&
                        header.text != 'Animal Identification'
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          style="margin-top: -4px; margin-left: -2px"
                          size="15"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-help-circle-outline</v-icon
                        >
                      </template>
                      <span
                        ><span class="font-weight-bold">{{
                          header.headerTitle
                        }}</span>
                        {{ header.headerDef }}</span
                      >
                    </v-tooltip>
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="item in geneticId"
                :key="item.id"
                class="align-table-tr tbody-tr"
              >
                <tr>
                  <!-- <td style="padding-top: 0px !important;">
                                    <v-checkbox
                                        @click="()=>{selectUsers(item.id)}"
                                        :value="item.id"
                                    ></v-checkbox>
                                </td> -->
                  <td>
                    <div class="custom-div">
                      <div class="data-1">
                        <p>
                          Reg #:
                          <v-btn
                            plain
                            elevation="0"
                            style="color: #00bd73; text-decoration: underline"
                            @click="singleResult(item.id)"
                            >{{
                              item.animal?.animalIdentification
                                ?.govRegistrationNo
                            }}</v-btn
                          >
                        </p>
                        <p>
                          Name :
                          <span>{{
                            item.animal?.animalIdentification?.livestockName
                          }}</span>
                        </p>
                        <p>
                          Tag # :
                          <span>{{
                            item.animal?.animalIdentification
                              ?.identificationMethods?.tagNumber
                          }}</span>
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="
                        item.animal?.animalIdentification?.identificationMethods
                          ?.imageUrl
                      "
                      style="margin-top: 30px; padding-left: 10px"
                    >
                      <v-img
                        height="144"
                        width="228"
                        :src="
                          item.animal?.animalIdentification
                            ?.identificationMethods?.imageUrl
                        "
                      ></v-img>
                    </div>
                    <div
                      v-if="item.animalImage == null"
                      style="margin-top: 14px; padding-left: 10px"
                    >
                      <v-img
                        height="217"
                        width="228"
                        src="/img/no_img.png"
                      ></v-img>
                    </div>
                  </td>
                  <td>
                    <div class="data-1">
                      <p>
                        Sex : <span>{{ item.gender }}</span>
                      </p>
                      <p>
                        Tattoo :
                        <span>{{
                          item.animal?.animalIdentification
                            ?.identificationMethods?.tatooName
                        }}</span>
                      </p>
                      <p>
                        DOB : <span>{{ item.birthDate }}</span>
                      </p>
                    </div>
                  </td>
                  <td style="white-space: nowrap; padding: 1px 18px !important">
                    <div style="align-items: end" class="data-1">
                      <p>EPD:</p>
                      <p>Acc:</p>
                      <p>% Rank:</p>
                    </div>
                  </td>

                  <td width="75px" class="text-left">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("birth_weight_epd") &&
                      item.birth_weight_epd != null
                        ? Number.isInteger(item.birth_weight_epd)
                          ? item.birth_weight_epd
                          : Number(item.birth_weight_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("birth_weight_accuracy") &&
                      item.birth_weight_accuracy != null
                        ? Number.isInteger(item.birth_weight_accuracy)
                          ? item.birth_weight_accuracy
                          : Number(item.birth_weight_accuracy).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("birth_weight_rank") &&
                      item.birth_weight_rank != null
                        ? Number.isInteger(item.birth_weight_rank)
                          ? item.birth_weight_rank
                          : Number(item.birth_weight_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>

                  <td width="75px" class="text-left">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("weaning_weight_epd") &&
                      item.weaning_weight_epd != null
                        ? Number.isInteger(item.weaning_weight_epd)
                          ? item.weaning_weight_epd
                          : Number(item.weaning_weight_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("weaning_weight_accuracy") &&
                      item.weaning_weight_accuracy != null
                        ? Number.isInteger(item.weaning_weight_accuracy)
                          ? item.weaning_weight_accuracy
                          : Number(item.weaning_weight_accuracy).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("weaning_weight_rank") &&
                      item.weaning_weight_rank != null
                        ? Number.isInteger(item.weaning_weight_rank)
                          ? item.weaning_weight_rank
                          : Number(item.weaning_weight_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td width="75px" class="text-left">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("yearling_weight_epd") &&
                      item.yearling_weight_epd != null
                        ? Number.isInteger(item.yearling_weight_epd)
                          ? item.yearling_weight_epd
                          : Number(item.yearling_weight_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("yearling_weight_accuracy") &&
                      item.yearling_weight_accuracy != null
                        ? Number.isInteger(item.yearling_weight_accuracy)
                          ? item.yearling_weight_accuracy
                          : Number(item.yearling_weight_accuracy).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>{{
                      item.hasOwnProperty("yearling_weight_rank") &&
                      item.yearling_weight_rank != null
                        ? Number.isInteger(item.yearling_weight_rank)
                          ? item.yearling_weight_rank
                          : Number(item.yearling_weight_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>

                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("ribEyeArea_epd") &&
                      item.ribEyeArea_epd != null
                        ? Number.isInteger(item.ribEyeArea_epd)
                          ? item.ribEyeArea_epd
                          : Number(item.ribEyeArea_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("ribEyeArea_rank") &&
                      item.ribEyeArea_rank != null
                        ? Number.isInteger(item.ribEyeArea_rank)
                          ? item.ribEyeArea_rank
                          : Number(item.ribEyeArea_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("marbling_epd") &&
                      item.marbling_epd != null
                        ? Number.isInteger(item.marbling_epd)
                          ? item.marbling_epd
                          : Number(item.marbling_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("marbling_rank") &&
                      item.marbling_rank != null
                        ? Number.isInteger(item.marbling_rank)
                          ? item.marbling_rank
                          : Number(item.marbling_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("fatThickness_epd") &&
                      item.fatThickness_epd != null
                        ? Number.isInteger(item.fatThickness_epd)
                          ? item.fatThickness_epd
                          : Number(item.fatThickness_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("fatThickness_rank") &&
                      item.fatThickness_rank != null
                        ? Number.isInteger(item.fatThickness_rank)
                          ? item.fatThickness_rank
                          : Number(item.fatThickness_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("carcass_weight_epd") &&
                      item.carcass_weight_epd != null
                        ? Number.isInteger(item.carcass_weight_epd)
                          ? item.carcass_weight_epd
                          : Number(item.carcass_weight_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("carcass_weight_rank") &&
                      item.carcass_weight_rank != null
                        ? Number.isInteger(item.carcass_weight_rank)
                          ? item.carcass_weight_rank
                          : Number(item.carcass_weight_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="text-start" width="75px">
                    <span v-if="item === null">-</span>

                    <span v-if="item !== null">{{
                      item.hasOwnProperty("yield_grade_epd") &&
                      item.yield_grade_epd != null
                        ? Number.isInteger(item.yield_grade_epd)
                          ? item.yield_grade_epd
                          : Number(item.yield_grade_epd).toFixed(2)
                        : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("yield_grade_rank") &&
                      item.yield_grade_rank != null
                        ? Number.isInteger(item.yield_grade_rank)
                          ? item.yield_grade_rank
                          : Number(item.yield_grade_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>

                  <td class="gray2 text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("milk_ability_epd") &&
                      item.milk_ability_epd != null
                        ? Number.isInteger(item.milk_ability_epd)
                          ? item.milk_ability_epd
                          : Number(item.milk_ability_epd).toFixed(2)
                        : "-"
                    }}</span>
                    <br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("milk_ability_accuracy") &&
                      item.milk_ability_accuracy != null
                        ? Number.isInteger(item.milk_ability_accuracy)
                          ? item.milk_ability_accuracy
                          : Number(item.milk_ability_accuracy).toFixed(2)
                        : "-"
                    }}</span>
                    <br />
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("milk_ability_rank") &&
                      item.milk_ability_rank != null
                        ? Number.isInteger(item.milk_ability_rank)
                          ? item.milk_ability_rank
                          : Number(item.milk_ability_rank).toFixed(2)
                        : "-"
                    }}</span>
                  </td>
                  <td class="gray2 text-start" width="75px">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("tm") ? item.tm : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                  </td>
                  <td class="gray2 text-start" width="5%">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("ced") ? item.ced : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                  </td>
                  <td class="gray2 text-start" width="5%">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("cem") ? item.cem : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                  </td>
                  <td class="gray2 text-start" width="5%">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("stay") ? item.stay : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                  </td>
                  <td class="gray2 text-start" width="5%">
                    <span v-if="item === null">-</span>
                    <span v-if="item !== null">{{
                      item.hasOwnProperty("doc") ? item.doc : "-"
                    }}</span
                    ><br />
                    <span>-</span><br />
                    <span>-</span>
                    <!-- <span class="tooltiptext">Coming Soon</span> -->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  mounted() {
    this.searchData = localStorage.getItem("searchData");
    this.searchTagData = localStorage.getItem("searchTagData");
    this.geneticId = localStorage.getItem("geneticCompareData");
    this.geneticId = JSON.parse(this.geneticId);
    console.log(this.geneticId);
  },
  watch: {},
  methods: {
    // back(){
    // localStorage.removeItem("geneticCompareData")
    // this.$router.push({name: 'GeneticSearchList'})
    // this.$router.go(-1)
    // },
    selectUsers(id) {
      if (this.checkbox.includes(id)) {
        const index = this.checkbox.indexOf(id);
        this.checkbox.splice(index, 1);
      } else {
        this.checkbox.push(id);
      }
      if (this.checkbox.length > 0) {
        this.checkboxx = true;
      } else {
        this.checkboxx = false;
      }
    },
    singleResult(geneticid) {
      console.log(geneticid);
      this.$router.push({ path: `/genetics/epd-info/${geneticid}` });
    },
  },

  data() {
    return {
      searchDataa: [],
      geneticId: [],
      searchTagData: {},
      options: { itemsPerPage: 10, page: 1 },
      searchData: {},
      checkboxx: false,
      checkbox: [],
      GeneticData: [],
      headers: [
        {
          text: this.$t(""),
          align: "start",
          value: "no-value",
          class: "text-no-wrap black--text",
          sortable: false,
          width: "100px",
          headerTitle: "",
          headerDef: "",
        },
        {
          text: this.$t(""),
          align: "start",
          value: "no-value2",
          class: "text-no-wrap black--text",
          sortable: false,
          width: "50px",
          headerTitle: "",
          headerDef: "",
        },
        {
          text: this.$t("BW"),
          value: "birth_weight_epd",
          class: "text-no-wrap black--text px-0",
          align: "center",
          sortable: true,
          width: "75x",
          headerTitle: "Birth Weight (BW): ",
          headerDef:
            "Compares the differences in the weight of calves at birth and is measured in pounds or kg.",
        },
        {
          text: this.$t("WW"),
          value: "weaning_weight_epd",
          class: "text-no-wrap black--text",
          align: "center",
          sortable: true,
          width: "75px",
          headerTitle: "Weaning Weight (WW): ",
          headerDef:
            "WW EPD is an estimate of pre-weaning growth that is measured in pounds or kg.",
        },
        {
          text: this.$t("YW"),
          value: "yearling_weight_epd",
          class: "text-no-wrap black--text",
          align: "center",
          sortable: true,
          width: "75px",
          headerTitle: "Yearling Weight (YW): ",
          headerDef:
            "YW EPD is an estimate of post-weaning growth that is measured in pounds or kg.",
        },
        {
          text: this.$t("REA"),
          value: "rea",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "75px",
          headerTitle: "Ribeye Area (REA): ",
          headerDef:
            "REA measures the size of the muscle that gives us the ribeye in square inches.REA EPDs reflect differences in an adjusted 365-day ribeye area measurement based on carcass measurements of harvested cattle.",
        },
        {
          text: this.$t("MARB"),
          value: "marb",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "85px",
          headerTitle: "Marbling (MARB): ",
          headerDef:
            "The MARB EPD is in units of percentage of intramuscular fat within the ribeye.MARB EPDs reflect differences in an adjusted 365-day marbling score (intramuscular fat, [IMF]) based on carcass measurements of harvested cattle.",
        },
        {
          text: this.$t("FAT"),
          value: "fat",
          align: "start",
          class: "black--text text-no-wrap px-0",
          sortable: false,
          width: "75px",
          headerTitle: "Fat Thickness (FAT): ",
          headerDef:
            "Inches of backfat (in hundredths of an inch) is the unit of measurement for FT.",
        },
        {
          text: this.$t("CW"),
          value: "cw",
          align: "center",
          class: "black--text text-no-wrap px-0",
          sortable: false,
          width: "75px",
          headerTitle: "Carcass Weight (CW): ",
          headerDef:
            "Carcass weight is a beneficial trait when considering the impact that pounds have relative to end product value. At the same age constant endpoint, sires with higher values for carcass weight will add more pounds of hot carcass weight compared to sires with lower values for carcass weight.",
        },

        {
          text: this.$t("YG"),
          value: "yg",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "75px",
          headerTitle: "Yield Grade (YG): ",
          headerDef:
            "The USDA Yield Grade scoring system is the unit of measurement for the YG EPD. Yield Grade 1 are leaner, more retail product carcasses.",
        },
        {
          text: this.$t("MILK"),
          value: "milk",
          class: "text-no-wrap black--text",
          align: "center",
          sortable: false,
          width: "75px",
          headerTitle: "Milk (MK): ",
          headerDef:
            "The MK EPD is measured in pounds of calf weaning weight due to his mother’s milking ability.",
        },
        {
          text: this.$t("TM"),
          value: "tm",
          class: "text-no-wrap black--text",
          sortable: false,
          align: "center",
          width: "75px",
          headerTitle: "Total Maternal (TM): ",
          headerDef:
            "TM measures impact on calf weaning weight due to both milk production and the cow’s genetics for growth.",
        },
        {
          text: this.$t("CED"),
          value: "ced",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "75px",
          headerTitle: "Calving Ease Direct (CED): ",
          headerDef:
            "The CED EPD is listed as a percentage of unassisted calvings.",
        },
        {
          text: this.$t("CEM"),
          value: "cem",
          align: "center",
          class: "black--text text-no-wrap px-0",
          sortable: false,
          width: "77px",
          headerTitle: "Calving Ease Maternal (CEM): ",
          headerDef:
            "Measures the ability of a bull’s daughters to calves unassisted as two year olds.",
        },
        {
          text: this.$t("STAY"),
          value: "stay",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "80px",
          headerTitle: "Stayability (STAY): ",
          headerDef:
            "The ST EPD predicts the ability of a bull to sire cows that “stay around”. The ST EPD is shown as a percentage of how much more likely a bull’s daughters will stay in your herd to the age of 6.",
        },
        {
          text: this.$t("DOC"),
          value: "doc",
          class: "black--text text-no-wrap px-0",
          align: "center",
          sortable: false,
          width: "78px",
          headerTitle: "Docility (DOC): ",
          headerDef: "DOC measures the temperament of the cattle.",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.custom-t {
  color: #1e1e1e;
  font-family: pop_Bold;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
}
.table-data {
  margin-left: 120px;
  white-space: nowrap;
}
.custom-td {
  display: flex;
}
.custom-tdi {
  font-size: 0.875rem !important;
  height: 244px !important;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

::v-deep .v-icon.v-icon {
  font-size: 18px;
}

::v-deep .custom-table td {
  padding: 18px 1px !important;
}
.custom-table .tbody-tr tr {
  vertical-align: text-top;
}
.custom-table th {
  white-space: nowrap;
}
::v-deep .v-input--selection-controls__ripple {
  border-radius: 50%;
  cursor: pointer;
  height: 0px;
  position: absolute;
  transition: inherit;
  width: 34px;
  left: -12px;
  top: calc(50% - 24px);
  margin: 7px;
}

.colorUnderline {
  color: #00bd73;
  text-decoration: underline;
}

::v-deep .pad {
  padding-left: 10px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0 18px 0 0;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}
.sty {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #1e1e1e;
}
.data-1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-right: 38px;
  padding-left: 10px;
}
.data-1 p {
  margin: 0px;
  color: #000;
  font-weight: 600;
  white-space: nowrap;
}
.data-1 p span {
  color: #575a5e;
}
.custom-div {
  display: flex;
  justify-content: space-between;
}
.align-table-tr tr {
  vertical-align: text-top;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 0px;
  min-width: 64px;
  padding: 0 16px;
}
</style>
